import { useContext } from 'react';
import SEOContext from '~/contexts/SEOContext';
import ChipCaretRight from '~/icons/ChipCaretRight';

export default function Breadcrumbs() {
  const { vanityUrl } = useContext(SEOContext);

  return vanityUrl?.keyword ? (
    <div
      className="flex gap-4 items-center relative t-body-s text-grey-5"
      data-qa="breadcrumbs"
    >
      <a
        href="/cars"
        className="text-grey-5"
        data-analytics-id="Breadcrumb base"
      >
        Used Cars
      </a>
      <ChipCaretRight />
      <a
        href={`/cars/${vanityUrl.path}`}
        className="text-grey-5"
        data-analytics-id="Breadcrumb path"
      >
        {vanityUrl.keyword}
      </a>
    </div>
  ) : null;
}
